import { Injectable, ModuleWithProviders } from '@angular/core';
import { UserManager, UserManagerSettings } from 'oidc-client-ts';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from '../Services/ConfigService';
import { AppModule } from '../app.module';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	// Observable navItem source
	private _authNavStatusSource = new BehaviorSubject<boolean>(false);
	// Observable navItem stream
	authNavStatus$ = this._authNavStatusSource.asObservable();

	private companyChangedSource = new BehaviorSubject<boolean>(false);
	// Observable navItem stream
	companyChanged$ = this.companyChangedSource.asObservable();

	private manager: UserManager = null;

	needsLogin: boolean = false;

	static forRoot(): ModuleWithProviders<AppModule> {
		return {
			ngModule: AppModule,
			providers: [
			]
		};
	}
	constructor(
		public configData: ConfigService) {
		this.manager = new UserManager(this.configData.jsAppConfig);
		this.manager.getUser().then(usr => {
			this.configData.user = usr;
			this._authNavStatusSource.next(this.isAuthenticated());
			if (usr && usr.expired) {
				this.updateUserInfo();
			}
			if (this.needsLogin) {
				this.login();
			}
		});
	}

	changeCompanySettings() {
		this.companyChangedSource.next(true);
	}


	login(url?: string) {
		if (this.manager) {
			var whereAreWe = url || window.location.href;
			this.needsLogin = false;
			return this.manager.signinRedirect({
				extraQueryParams: {
					sc: this.configData.getSubDomain(whereAreWe),
					returnUrl: whereAreWe
				},
				state: {
					redirectPath: whereAreWe
				}
			});
		} else {
			this.needsLogin = true;
			return this.manager.clearStaleState();
		}
	}

	async completeAuthentication(): Promise<string> {
		this.configData.user = await this.manager.signinRedirectCallback();
		this._authNavStatusSource.next(this.isAuthenticated());
		var state: any = this.configData?.user?.state;
		var returnVal = state?.redirectPath || '';
		await this.manager.clearStaleState();
		return returnVal;
	}

	isAuthedButExpired(): boolean {
		return this.configData.user != null && this.configData.user.expired;
	}
	isAuthenticated(): boolean {
		return this.configData.user != null && !this.configData.user.expired;
	}

	clearUserInfo(): Promise<void> {
		var thisHolder = this;
		thisHolder.configData.user = null;
		if (thisHolder.manager) {
			return thisHolder.manager.removeUser()
				.then(() => {
					return thisHolder.updateUserInfo();
				});
		} else {
			return Promise.resolve();
		}
	}

	updateUserInfo(): Promise<void> {
		var thisHolder = this;
		if (thisHolder.manager) {
			return thisHolder.manager.signinSilent().then(user => {
				thisHolder.configData.user = user;
				thisHolder._authNavStatusSource.next(thisHolder.isAuthenticated());
			});
		}
		return Promise.resolve();
	}

	get name(): string {
		return this.configData.name();
	}
	silentCallback(): Promise<void>{
		var thisHolder = this;
		if (thisHolder.manager) {
			return this.manager.signinSilentCallback();
		}
		return Promise.resolve();
	}
	async signout() {
		var thisHolder = this;
		if (thisHolder.manager) {
			this.manager.clearStaleState();
			await this.manager.signoutRedirect();
		}
	}
}
